import React from "react";
import Lottie from "react-lottie";
import { useMediaQuery, useTheme } from "@mui/material";
import logoLoaderAnimation from "../animations/new_Logo_loader_lottie.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: logoLoaderAnimation,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid meet",
  },
};

/**
 * Responsive logo loader: ~200px mobile, ~260px tablet, ~320px desktop.
 * Pass height/width to override.
 */
function LogoLoaderLottie({ height, width }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // < 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900px

  const size = (() => {
    if (height != null && width != null) return { height, width };
    if (isMobile) return { height: 200, width: 200 };
    if (isTablet) return { height: 260, width: 260 };
    return { height: 320, width: 320 };
  })();

  return (
    <Lottie options={defaultOptions} height={size.height} width={size.width} />
  );
}

export default LogoLoaderLottie;
